module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tipo da conta')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Tipo da Conta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.tiposConta,
      "multiple": false,
      "close-on-select": true,
      "preselect-first": true,
      "allow-empty": false,
      "custom-label": _vm.tipoContaNome,
      "placeholder": "Selecione um tipo de conta",
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "",
      "deselectLabel": "",
      "name": "tipo da conta",
      "data-vv-as": "tipo da conta",
      "disabled": _vm.$attrs.disabled
    },
    on: {
      "select": _vm.selecionaTipoConta
    },
    model: {
      value: (_vm.tipoContaSelecionado),
      callback: function($$v) {
        _vm.tipoContaSelecionado = $$v
      },
      expression: "tipoContaSelecionado"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('tipo da conta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tipo da conta')))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fae5ec5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/adiantamento/componentes/tipoConta.vue
// module id = 1950
// module chunks = 1